import { AxiosForLegacyBackend } from "../../utils/helpers/AxiosForLegacyBackend";
import AxiosRaw from "axios";
import { type POSADeliveryWithBill } from "../../app/12_POSAManager/api";
import type GetPaymentIntentResponse from "./model/GetPaymentIntentResponse";
import CONFIG from "../../model/TSConfig";

export default class PaymentFormAPI {
  public static async completeSubscription(
    businessUserId: string,
    saasPlanId: string | undefined | null,
    saasCommitment: string | undefined | null,
    payment_intent_id: string,
    startTs: number,
    promoCode: string | undefined | null,
    promoCode2: string | undefined | null,
    token: string | undefined,
    setup_intent_id?: string
  ) {
    const res = await AxiosRaw({
      method: "POST",
      url: `${CONFIG.saasBackendUrl}/subscription`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      data: {
        businessUserId,
        saasPlanId,
        saasCommitment,
        payment_intent_id,
        startTs,
        promoCode,
        promoCode2,
        setup_intent_id
      }
    });

    return res.data;
  }

  public static afterStripePayment = async (
    businessUserId: string,
    billId: string,
    posaDeliveryIds: string[],
    payment_intent_id: string,
    token: string | undefined
  ): Promise<POSADeliveryWithBill[]> => {
    const res = await AxiosRaw({
      method: "PUT",
      url: `${CONFIG.saasBackendUrl}/posa-delivery/after-stripe-payment`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      data: {
        businessUserId,
        billId,
        posaDeliveryIds,
        paymentIntentId: payment_intent_id
      }
    });

    if (res.data.code && res.data.code !== 0) {
      throw new Error(JSON.stringify(res.data));
    }

    return res.data.deliveries;
  };

  public static createStripePaymentIntent = async (
    businessUserId: string,
    posaDeliveryIds: string[],
    billId: string,
    cardId?: string
  ) => {
    const res = await AxiosForLegacyBackend({
      method: "POST",
      url: "/payment/intent",
      params: {
        businessUserId,
        billId,
        cardId
      },
      data: posaDeliveryIds
    });
    return res.data;
  };

  public static createStripePaymentIntentWithoutBill = async (
    businessUserId: string,
    amount: number,
    cardId?: string
    // promoCode?: string
  ): Promise<GetPaymentIntentResponse> => {
    const res = await AxiosForLegacyBackend({
      method: "POST",
      url: "/payment/intent/blank",
      params: {
        businessUserId,
        cardId,
        amount: Math.trunc(amount)
      }
    });
    return res.data;
  };

  public static createStripeSetupIntent = async (
    businessUserId: string
  ): Promise<{ clientSecret: string; setupIntentId: string }> => {
    const res = await AxiosForLegacyBackend({
      method: "POST",
      url: "/payment/setup-intent",
      params: {
        businessUserId
      }
    });
    return res.data;
  };
}
